import React from 'react'

const BotListSkeleton = ({rows}) => {
    return (
        <>
            <style>
                {
                    `
                        .skeleton {
                            animation: pulse 1.5s infinite ease-in-out !important;
                            background: #d5d6d8ff !important;
                            border-radius: 3px !important;
                        }
                        @keyframes pulse {
                            0%, 100% {
                                opacity: 1;
                            }
                            50% {
                                opacity: 0.4;
                            }
                        }
                    `
                }
            </style>
            <div className="table-responsive">
                <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">
                    <thead>
                        <tr className="fs-7 fw-bold text-gray-400 border-bottom-0">
                            <th className="" style={{minWidth: '250px'}}>
                                Name
                            </th>
                            <th className="">
                                Description
                            </th>
                            <th className="" style={{minWidth: '100px'}}>
                                Status
                            </th>
                            <th className="" style={{minWidth: '100px'}}>
                                Channel
                            </th>
                            <th className="" style={{minWidth: '100px'}}>
                                Language
                            </th>
                            <th className="" style={{minWidth: '130px'}}>
                                Last Updated On
                            </th>
                            <th className="">
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {[...Array(rows)].map((_, index) => (
                            <tr key={index}>
                                <td>
                                    <div className="d-flex">
                                        <div className="symbol symbol-50px me-3">
                                            <span className="symbol-label fs-2 fw-bold text-primary text-uppercase">
                                                <div className='skeleton rounded' style={{height:'50px', width:'50px'}}></div>
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-start flex-column mt-3">
                                            <a className="text-gray-800 fw-bold mb-1 fs-6">
                                                <div className='skeleton' style={{width:'150px', height:'15px'}}></div>
                                            </a>
                                            <span className="text-gray-400 fw-semibold d-block fs-7">
                                                <span className='badge badge-light fs-base'>
                                                    <div className='skeleton' style={{width:'140px', height:'10px'}}></div>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td className="">
                                    <span className="text-gray-600 fs-6">
                                        <div className='skeleton' style={{width:'140px', height:'10px'}}></div>
                                    </span>
                                </td>
                                <td className="">
                                    <div className='skeleton' style={{width:'50px', height:'10px'}}></div>
                                </td>
                                <td className="">
                                    <span className="text-gray-600 fw-bold fs-6">
                                        <div className='skeleton' style={{width:'70px', height:'10px'}}></div>
                                    </span>
                                </td>
                                <td className="">
                                    <span className="text-gray-600 fw-bold fs-6">
                                        <div className='skeleton' style={{width:'70px', height:'10px'}}></div>
                                    </span>
                                </td>
                                <td className="">
                                    <span className="text-gray-600 fw-bold fs-6">
                                        <div className='skeleton' style={{width:'70px', height:'10px'}}></div>
                                    </span>
                                </td>
                                <td className="" style={{borderBottom: 'none'}}>
                                    <div className='skeleton' style={{width:'30px', height:'30px'}}></div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default BotListSkeleton